export const LANGS = [
  { code: 'en', name: 'English',    flag: '🇬🇧' },
  { code: 'es', name: 'Español',    flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'fr', name: 'Français',   flag: '🇫🇷' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'sv', name: 'Svenska',    flag: '🇸🇪' },
  { code: 'da', name: 'Dansk',      flag: '🇩🇰' },
  { code: 'nb', name: 'Norsk',      flag: '🇳🇴' },
  { code: 'fi', name: 'Suomi',      flag: '🇫🇮' },
  { code: 'it', name: 'Italiano',   flag: '🇮🇹' },
  { code: 'pt', name: 'Português',  flag: '🇵🇹' },
  { code: 'ru', name: 'Русский',    flag: '🇷🇺' },
  { code: 'pl', name: 'Polski',     flag: '🇵🇱' },
  { code: 'cs', name: 'Čeština',    flag: '🇨🇿' },
  { code: 'ro', name: 'Română',     flag: '🇷🇴' },
  { code: 'zh', name: '中文',       flag: '🇨🇳' },
];

export const LANG_CODES = LANGS.map((l) => l.code);
export const LANG_MAP = Object.fromEntries(LANGS.map((l) => [l.code, l]));
